import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

const initialState: string = `Это письмо направлено для того, чтобы уведомить Вас в том, что долг не был оплачен в полном обеме`;

export const emailContentSlice = createSlice({
 name: 'emailContent',
 initialState,
 reducers: {
  emailContent: (state, action: PayloadAction<string>) => {
   state = action.payload;
   return state;
  },
 },
});

export const { emailContent } = emailContentSlice.actions;

export default emailContentSlice.reducer;
